module.exports = __webpack_public_path__ + "static/media/paris_florist_getty_tablet.acabb48b.jpg";